<ui-list uiItemLayout="horizontal" [uiDataSource]="contributors">
  <ui-list-item
    class="ui-list-item"
    *ngFor="let contributor of contributors"
    (click)="selectContributor(contributor)"
    [ngClass]="{ active: isContributorCurrent(contributor.id) }"
    ui-tooltip
    [uiTooltipTitle]="contributor.name | localize"
    uiTooltipPlacement="right"
    [uiTooltipTrigger]="contributor.name.length > 20 ? 'hover' : null"
    uiTooltipOverlayClassName="gray-10-tooltip">
    <ui-list-item-meta [uiAvatar]="contributor.avatar">
      <ui-list-item-meta-title>
        <div ui-row uiJustify="space-between" uiAlign="middle">
          <div ui-col>
            <span class="ui-list-item-meta-title">{{ contributor.name | cut: { wordwise: false, max: 20 } }}</span>
          </div>
          <div ui-col *ngIf="contributor.withDotIndicator">
            <div class="blue-dot"></div>
          </div>
        </div>
      </ui-list-item-meta-title>
    </ui-list-item-meta>
  </ui-list-item>
  <ui-list-empty *ngIf="contributors.length === 0"></ui-list-empty>
</ui-list>
